<app-graph
    (load)="saveInstance($event.context)"
    [chartOptions]="rainFallMonitorChartOption"
    [initChart]="true"
></app-graph>
